import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { Header } from '../layout';

const Profile = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  const userTypeLabels = {
    capoarea: 'Capo Area',
    agente: 'Agente',
    partner: 'Partner',
    cliente: 'Cliente'
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <Header
        title="Profilo Utente"
        backText="Dashboard"
        backTo="/dashboard"
      />

      <div className="container mx-auto px-4 py-6">
        <div className="max-w-lg mx-auto">
          {/* User Info Card */}
          <div className="bg-white rounded-lg shadow-md p-6 mb-6">
            <div className="flex items-center space-x-4 mb-6">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
                <span className="text-2xl text-red-500">
                  {user?.code?.charAt(0)?.toUpperCase() || 'U'}
                </span>
              </div>
              <div>
                <h2 className="text-xl font-bold">Codice: {user?.code}</h2>
                <p className="text-gray-600">{userTypeLabels[user?.type]}</p>
              </div>
            </div>
          </div>

          {/* Quick Actions */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden">
            <div className="divide-y">
              <button
                onClick={() => navigate('/orders')}
                className="w-full px-6 py-4 text-left hover:bg-gray-50 flex justify-between items-center"
              >
                <span>I miei ordini</span>
                <span className="text-gray-400">→</span>
              </button>

              <button
                onClick={() => navigate('/documents')}
                className="w-full px-6 py-4 text-left hover:bg-gray-50 flex justify-between items-center"
              >
                <span>Documenti</span>
                <span className="text-gray-400">→</span>
              </button>

              {(user?.type === 'capoarea' || user?.type === 'agente') && (
                <button
                  onClick={() => navigate('/clients')}
                  className="w-full px-6 py-4 text-left hover:bg-gray-50 flex justify-between items-center"
                >
                  <span>Gestione Clienti</span>
                  <span className="text-gray-400">→</span>
                </button>
              )}

              <button
                onClick={() => setShowLogoutConfirm(true)}
                className="w-full px-6 py-4 text-left text-red-600 hover:bg-red-50"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Logout Confirmation Modal */}
      {showLogoutConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg p-6 max-w-sm w-full">
            <h3 className="text-lg font-semibold mb-4">Conferma Logout</h3>
            <p className="text-gray-600 mb-6">
              Sei sicuro di voler effettuare il logout?
            </p>
            <div className="flex space-x-4">
              <button
                onClick={() => setShowLogoutConfirm(false)}
                className="flex-1 px-4 py-2 border border-gray-300 rounded-lg"
              >
                Annulla
              </button>
              <button
                onClick={logout}
                className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};


export default Profile;
